// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/bg.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/bg2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/bg3.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page {
  padding: 0;
  max-width: 100%;
}

.hero-section {
  margin-top: 10px;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

.grid-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image:
    linear-gradient(rgba(0, 163, 255, 0.1) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 163, 255, 0.1) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: gridMove 20s linear infinite;
}

@keyframes gridMove {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(50px, 50px);
  }
}

.particle {
  position: absolute;
  border-radius: 50%;
  filter: blur(40px);
  animation: float 8s infinite ease-in-out;
}

.particle-1 {
  width: 300px;
  height: 300px;
  background: radial-gradient(
    circle,
    rgba(0, 163, 255, 0.3) 0%,
    transparent 70%
  );
  top: 10%;
  left: 10%;
  animation-delay: 0s;
}

.particle-2 {
  width: 400px;
  height: 400px;
  background: radial-gradient(
    circle,
    rgba(0, 163, 255, 0.2) 0%,
    transparent 70%
  );
  bottom: 10%;
  right: 10%;
  animation-delay: 2s;
}

.particle-3 {
  width: 250px;
  height: 250px;
  background: radial-gradient(
    circle,
    rgba(0, 163, 255, 0.25) 0%,
    transparent 70%
  );
  top: 50%;
  left: 50%;
  animation-delay: 4s;
}

@keyframes float {
  0%,
  100% {
    transform: translate(0, 0);
  }
  33% {
    transform: translate(30px, -30px);
  }
  66% {
    transform: translate(-20px, 20px);
  }
}

.hero-content {
  position: relative;
  z-index: 1;
  height: 600px;
  padding: 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center/cover;
}

.hero-content2 {
  position: relative;
  z-index: 1;
  height: 600px;
  padding: 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center/cover;
}

.hero-content3 {
  position: relative;
  z-index: 1;
  height: 600px;
  padding: 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center center/cover;
}

.hero-title {
  font-size: 4.5rem;
  font-weight: 800;
  margin-bottom: 1.5rem;
  line-height: 1.1;
}

.gradient-text {
  background: linear-gradient(135deg, #ffffff 0%, #00a3ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: shimmer 3s infinite;
}

@keyframes shimmer {
  0%,
  100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

.hero-subtitle {
  font-size: 3.5rem;
  color: #fff;
  margin-bottom: 3rem;
  font-weight: 300;
}
  .hero-subtitle2 {
    font-size: 1rem;
    color: #fff;
  }
.hero-buttons {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;
}

.cta-button {
  position: relative;
  padding: 1.2rem 3rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: white;
  background: linear-gradient(135deg, #0f3460 0%, #00a3ff 100%);
  border: 2px solid #00a3ff;
  border-radius: 50px;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(0, 163, 255, 0.3);
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.cta-button.secondary {
  background: transparent;
  border: 2px solid #00a3ff;
}

.cta-button.large {
  padding: 1.4rem 3.5rem;
  font-size: 1.2rem;
}

.cta-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 30px rgba(0, 163, 255, 0.5);
}

.cta-button span {
  position: relative;
  z-index: 1;
}

.button-glow {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
    45deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  transform: rotate(45deg);
  animation: buttonGlow 3s infinite;
}

@keyframes buttonGlow {
  0% {
    transform: rotate(45deg) translate(-100%, -100%);
  }
  100% {
    transform: rotate(45deg) translate(100%, 100%);
  }
}

.features-section {
  padding: 5rem 2rem;
  max-width: 1400px;
  margin: 0 auto;
  background: #000000;
}

.section-header {
  text-align: center;
  margin-bottom: 4rem;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, #ffffff 0%, #00a3ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-subtitle {
  font-size: 1.2rem;
  color: #b0b0b0;
}

.bar-text {
  text-align: center;
  margin-top: 200px;
  margin-left: 15%;
  width: 70%;
}
.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
}

.feature-card {
  background: linear-gradient(135deg, #1a1a2e 0%, #0f3460 100%);
  padding: 2.5rem;
  border-radius: 16px;
  border: 1px solid rgba(0, 163, 255, 0.2);
  transition: all 0.3s ease;
  text-align: center;
}

.feature-card:hover {
  transform: translateY(-8px);
  border-color: #00a3ff;
  box-shadow: 0 8px 30px rgba(0, 163, 255, 0.3);
}

.feature-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 1.5rem;
  background: linear-gradient(
    135deg,
    rgba(0, 163, 255, 0.2) 0%,
    rgba(0, 163, 255, 0.1) 100%
  );
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #00a3ff;
  border: 2px solid rgba(0, 163, 255, 0.3);
}

.feature-card h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #ffffff;
}

.feature-card p {
  color: #b0b0b0;
  line-height: 1.6;
}

.cta-section {
  padding: 5rem 2rem;
  background: linear-gradient(135deg, #0f3460 0%, #1a1a2e 100%);
  text-align: center;
}

.cta-content {
  max-width: 800px;
  margin: 0 auto;
}

.cta-content h2 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: #ffffff;
}

.cta-content p {
  font-size: 1.2rem;
  color: #b0b0b0;
  margin-bottom: 2.5rem;
}

@media (max-width: 968px) {
  .hero-title {
    font-size: 3rem;
  }

  .hero-subtitle {
    font-size: 3.5rem;
    color: #fff;
  }
  .hero-subtitle2 {
    font-size: 3.5rem;
    color: #2f7dbd !important;
  }

  .hero-buttons {
    flex-direction: column;
    align-items: center;
  }

  .cta-button {
    width: 100%;
    max-width: 300px;
  }

  .features-grid {
    grid-template-columns: 1fr;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .section-title {
    font-size: 2rem;
  }

  .cta-content h2 {
    font-size: 2rem;
  }
}

@media (max-width: 640px) {
  .hero-title {
    font-size: 2.5rem;
  }

  .hero-subtitle {
    font-size: 1rem;
    color: #fff;
  }

  .features-section,
  .cta-section {
    padding: 3rem 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/Home.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;uEAEqE;EACrE,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb;;;;GAIC;EACD,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb;;;;GAIC;EACD,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb;;;;GAIC;EACD,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,aAAa;EACb,iFAA4E;AAC9E;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,aAAa;EACb,iFAA4E;AAC9E;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,aAAa;EACb,iFAA6E;AAC/E;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE;;IAEE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;EACE;IACE,eAAe;IACf,WAAW;EACb;AACF;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,6CAA6C;EAC7C,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE;IACE,gDAAgD;EAClD;EACA;IACE,8CAA8C;EAChD;AACF;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB;;;;GAIC;EACD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;;IAEE,kBAAkB;EACpB;AACF","sourcesContent":[".home-page {\n  padding: 0;\n  max-width: 100%;\n}\n\n.hero-section {\n  margin-top: 10px;\n}\n\n.hero-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n}\n\n.grid-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-image:\n    linear-gradient(rgba(0, 163, 255, 0.1) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(0, 163, 255, 0.1) 1px, transparent 1px);\n  background-size: 50px 50px;\n  animation: gridMove 20s linear infinite;\n}\n\n@keyframes gridMove {\n  0% {\n    transform: translate(0, 0);\n  }\n  100% {\n    transform: translate(50px, 50px);\n  }\n}\n\n.particle {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(40px);\n  animation: float 8s infinite ease-in-out;\n}\n\n.particle-1 {\n  width: 300px;\n  height: 300px;\n  background: radial-gradient(\n    circle,\n    rgba(0, 163, 255, 0.3) 0%,\n    transparent 70%\n  );\n  top: 10%;\n  left: 10%;\n  animation-delay: 0s;\n}\n\n.particle-2 {\n  width: 400px;\n  height: 400px;\n  background: radial-gradient(\n    circle,\n    rgba(0, 163, 255, 0.2) 0%,\n    transparent 70%\n  );\n  bottom: 10%;\n  right: 10%;\n  animation-delay: 2s;\n}\n\n.particle-3 {\n  width: 250px;\n  height: 250px;\n  background: radial-gradient(\n    circle,\n    rgba(0, 163, 255, 0.25) 0%,\n    transparent 70%\n  );\n  top: 50%;\n  left: 50%;\n  animation-delay: 4s;\n}\n\n@keyframes float {\n  0%,\n  100% {\n    transform: translate(0, 0);\n  }\n  33% {\n    transform: translate(30px, -30px);\n  }\n  66% {\n    transform: translate(-20px, 20px);\n  }\n}\n\n.hero-content {\n  position: relative;\n  z-index: 1;\n  height: 600px;\n  padding: 2rem;\n  background: url(\"../../assets/images/bg.jpeg\") no-repeat center center/cover;\n}\n\n.hero-content2 {\n  position: relative;\n  z-index: 1;\n  height: 600px;\n  padding: 2rem;\n  background: url(\"../../assets/images/bg2.png\") no-repeat center center/cover;\n}\n\n.hero-content3 {\n  position: relative;\n  z-index: 1;\n  height: 600px;\n  padding: 2rem;\n  background: url(\"../../assets/images/bg3.jpeg\") no-repeat center center/cover;\n}\n\n.hero-title {\n  font-size: 4.5rem;\n  font-weight: 800;\n  margin-bottom: 1.5rem;\n  line-height: 1.1;\n}\n\n.gradient-text {\n  background: linear-gradient(135deg, #ffffff 0%, #00a3ff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  animation: shimmer 3s infinite;\n}\n\n@keyframes shimmer {\n  0%,\n  100% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n}\n\n.hero-subtitle {\n  font-size: 3.5rem;\n  color: #fff;\n  margin-bottom: 3rem;\n  font-weight: 300;\n}\n  .hero-subtitle2 {\n    font-size: 1rem;\n    color: #fff;\n  }\n.hero-buttons {\n  display: flex;\n  gap: 1.5rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.cta-button {\n  position: relative;\n  padding: 1.2rem 3rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: white;\n  background: linear-gradient(135deg, #0f3460 0%, #00a3ff 100%);\n  border: 2px solid #00a3ff;\n  border-radius: 50px;\n  cursor: pointer;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 20px rgba(0, 163, 255, 0.3);\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cta-button.secondary {\n  background: transparent;\n  border: 2px solid #00a3ff;\n}\n\n.cta-button.large {\n  padding: 1.4rem 3.5rem;\n  font-size: 1.2rem;\n}\n\n.cta-button:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 30px rgba(0, 163, 255, 0.5);\n}\n\n.cta-button span {\n  position: relative;\n  z-index: 1;\n}\n\n.button-glow {\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  width: 200%;\n  height: 200%;\n  background: linear-gradient(\n    45deg,\n    transparent,\n    rgba(255, 255, 255, 0.3),\n    transparent\n  );\n  transform: rotate(45deg);\n  animation: buttonGlow 3s infinite;\n}\n\n@keyframes buttonGlow {\n  0% {\n    transform: rotate(45deg) translate(-100%, -100%);\n  }\n  100% {\n    transform: rotate(45deg) translate(100%, 100%);\n  }\n}\n\n.features-section {\n  padding: 5rem 2rem;\n  max-width: 1400px;\n  margin: 0 auto;\n  background: #000000;\n}\n\n.section-header {\n  text-align: center;\n  margin-bottom: 4rem;\n}\n\n.section-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n  background: linear-gradient(135deg, #ffffff 0%, #00a3ff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.section-subtitle {\n  font-size: 1.2rem;\n  color: #b0b0b0;\n}\n\n.bar-text {\n  text-align: center;\n  margin-top: 200px;\n  margin-left: 15%;\n  width: 70%;\n}\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 2rem;\n}\n\n.feature-card {\n  background: linear-gradient(135deg, #1a1a2e 0%, #0f3460 100%);\n  padding: 2.5rem;\n  border-radius: 16px;\n  border: 1px solid rgba(0, 163, 255, 0.2);\n  transition: all 0.3s ease;\n  text-align: center;\n}\n\n.feature-card:hover {\n  transform: translateY(-8px);\n  border-color: #00a3ff;\n  box-shadow: 0 8px 30px rgba(0, 163, 255, 0.3);\n}\n\n.feature-icon {\n  width: 80px;\n  height: 80px;\n  margin: 0 auto 1.5rem;\n  background: linear-gradient(\n    135deg,\n    rgba(0, 163, 255, 0.2) 0%,\n    rgba(0, 163, 255, 0.1) 100%\n  );\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #00a3ff;\n  border: 2px solid rgba(0, 163, 255, 0.3);\n}\n\n.feature-card h3 {\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n  color: #ffffff;\n}\n\n.feature-card p {\n  color: #b0b0b0;\n  line-height: 1.6;\n}\n\n.cta-section {\n  padding: 5rem 2rem;\n  background: linear-gradient(135deg, #0f3460 0%, #1a1a2e 100%);\n  text-align: center;\n}\n\n.cta-content {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.cta-content h2 {\n  font-size: 2.5rem;\n  margin-bottom: 1rem;\n  color: #ffffff;\n}\n\n.cta-content p {\n  font-size: 1.2rem;\n  color: #b0b0b0;\n  margin-bottom: 2.5rem;\n}\n\n@media (max-width: 968px) {\n  .hero-title {\n    font-size: 3rem;\n  }\n\n  .hero-subtitle {\n    font-size: 3.5rem;\n    color: #fff;\n  }\n  .hero-subtitle2 {\n    font-size: 3.5rem;\n    color: #2f7dbd !important;\n  }\n\n  .hero-buttons {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .cta-button {\n    width: 100%;\n    max-width: 300px;\n  }\n\n  .features-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .footer-content {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n  }\n\n  .section-title {\n    font-size: 2rem;\n  }\n\n  .cta-content h2 {\n    font-size: 2rem;\n  }\n}\n\n@media (max-width: 640px) {\n  .hero-title {\n    font-size: 2.5rem;\n  }\n\n  .hero-subtitle {\n    font-size: 1rem;\n    color: #fff;\n  }\n\n  .features-section,\n  .cta-section {\n    padding: 3rem 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
